/**
 * React Query keys for the account console.
 *
 * One canonical shape per read: a caller that invents its own param object
 * mints a second cache entry and re-fetches the identical endpoint.
 */
export const ACCOUNT_BILLING_KEYS = {
  dashboard: ['account', 'billing', 'dashboard'] as const,
  subscription: ['account', 'billing', 'subscription'] as const,
  plans: ['account', 'billing', 'plans'] as const,
  paymentMethods: ['account', 'billing', 'payment-methods'] as const,
  invoices: ['account', 'billing', 'invoices'] as const,
  contact: ['account', 'billing', 'contact'] as const,
};

export const ACCOUNT_ORG_KEYS = {
  profile: ['account', 'organization', 'profile'] as const,
  /** Summary count for the overview. */
  membersSummary: ['account', 'organization', 'members', 'summary'] as const,
  /** The paged list rendered in the Organization section. */
  membersList: ['account', 'organization', 'members', 'list'] as const,
  invitations: ['account', 'organization', 'invitations'] as const,
  roles: ['account', 'organization', 'roles'] as const,
};

export const ACCOUNT_USER_KEYS = {
  profile: ['account', 'my-profile'] as const,
  timezone: ['account', 'my-timezone'] as const,
  mfa: ['account', 'mfa', 'status'] as const,
  sessions: ['account', 'sessions'] as const,
};
